import AppState from './AppState.js';
import RootStore from './RootStore.js';
import SystemStore from './SystemStore.js';
import DeviceStore from './DeviceStore.js';
import Shard from './Shard.js';

// v2.0
const databases = {};

/**
 * @function registerDatabase adds a database class to the databases object
 * @param {string} type the look up string for the database
 * @param {class} clzz the class for creating databases
 */
function registerDatabase(type, clzz) {
  databases[type] = clzz;
}

/**
 * @function createDatabase creates a database of options.type
 * @param {object} options 
 * @param {string} options.type the type of database to be created
 */
function createDatabase(options) {
  if (options == null) {
    return null;
  }
  if (options.type === 'firebase') {
    const Clzz = databases[options.type];
    return Clzz != null ? new Clzz(options) : null;
  }
  return null;
}

// v2.1
const libs = {};

/**
 * @function registerLib adds a library to the lib object
 * @param {string} type the string that lib gets registered under
 * @param {any} lib the library to be registered
 */
function registerLib(type, lib) {
  libs[type] = lib;
}

/**
 * @function createRootStore creates a store with the root store class
 * @param {object} options 
 */
function createRootStore(options) {
  return createStoreOfType(options, RootStore);
}

/**
 * @function createSystemStore creates a store with the system store class
 * @param {object} options 
 */
function createSystemStore(options) {
  return createStoreOfType(options, SystemStore);
}

/**
 * @function createDeviceStore creates a store with the device store class
 * @param {object} options 
 */
function createDeviceStore(options) {
  return createStoreOfType(options, DeviceStore);
}

/**
 * @function createStoreOfType creates a data store with the lib of options.type
 * @param {object} options 
 * @param {string} options.type the type of lib to be used in the database creation
 * @param {class} ClassType the class to be created
 */
function createStoreOfType(options, ClassType) {
  if (options == null) {
    return null;
  }
  if (options.type === 'firebase') {
    const lib = libs[options.type];
    return ClassType != null ? new ClassType(options, lib) : null;
  }
  return null;
}

/**
 * @function createAppState Creates an AppState object from the given arguments:
 * @param options either a config object, or a database
 * @param name the name of AppState to attach too. If null/undefined the options.appName or  db.options.appName will be used.
 **/
function createAppState(options, name) {
  const db = typeof options.service === 'function' ? options : createDatabase(options);
  return db && new AppState(db, name);
}
export default {
  registerLib,
  createRootStore,
  createSystemStore,
  createDeviceStore,
  registerDatabase,
  createDatabase,
  createAppState,
  AppState,
  Shard
};